<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="formFilter">
        </sm-form>
        <p-button icon="fas fa-search" label="Suche" (onClick)="search()"></p-button>
    </p-panel>
    <sm-table2 *ngIf="table != null" class="flex-item-fill height100p" [data]="table" (onCellClicked)="clickCell($event)"></sm-table2>
</div>
